import { GetServerSideProps, InferGetServerSidePropsType } from 'next'
import DAppRaffleSingle from '../../modules/dApp/DAppRaffleSingle'
import DAppLayout from '../../modules/dApp/layouts/DAppLayout'
import { getRaffleById } from '../../modules/techRaffles/services/RaffleService'
import { raffleTypeWithLikeCount } from '../../modules/techRaffles/types'
import superjson from 'superjson'

interface ServerData {
  raffleJson: string
}

export const getServerSideProps: GetServerSideProps<ServerData> = async ({ req, res, params }) => {
  const raffleId = params?.id

  if (!raffleId) {
    return {
      redirect: {
        destination: '/',
        permanent: false,
      },
    }
  }

  const raffle = await getRaffleById(raffleId as string)

  if (!raffle) {
    return {
      redirect: {
        destination: '/',
        permanent: false,
      },
    }
  }

  return {
    props: {
      raffleJson: superjson.stringify(raffle),
    },
  }
}

export default function RaffleDetail({ raffleJson }: InferGetServerSidePropsType<typeof getServerSideProps>) {
  const raffle = superjson.parse<raffleTypeWithLikeCount>(raffleJson)

  return (
    <DAppLayout
      meta={{
        title: raffle.name,
        description: `Monet Raffle for ${raffle.name}`,
        previewImage: raffle.newRaffleImageUrl ?? raffle.imageUrl,
      }}
    >
      <DAppRaffleSingle raffle={raffle}></DAppRaffleSingle>
    </DAppLayout>
  )
}
